// The backend runs as a Vercel serverless function, which rejects any request
// body over ~4.5 MB with a 413 before the handler even sees it. Photos straight
// off a phone are routinely bigger than that, so shrink images in the browser
// before they are uploaded.

var MAX_DIMENSION = 1600;
var QUALITY = 0.82;
var SKIP_BELOW_BYTES = 500 * 1024;

function loadImage(file) {
  return new Promise(function (resolve, reject) {
    var url = URL.createObjectURL(file);
    var img = new window.Image();
    img.onload = function () { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('load failed')); };
    img.src = url;
  });
}

// Returns a File no larger than MAX_DIMENSION on its longest side, or the
// original file when it is already small or cannot be processed (GIF, SVG,
// a decode failure — never block an upload because of this).
export async function compressImage(file) {
  if (!file || !file.type || file.type.indexOf('image/') !== 0) return file;
  if (file.type === 'image/gif' || file.type === 'image/svg+xml') return file;
  if (file.size <= SKIP_BELOW_BYTES) return file;

  try {
    var img = await loadImage(file);
    var scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
    var w = Math.round(img.width * scale);
    var h = Math.round(img.height * scale);

    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    canvas.getContext('2d').drawImage(img, 0, 0, w, h);

    var blob = await new Promise(function (resolve) {
      canvas.toBlob(resolve, 'image/jpeg', QUALITY);
    });
    if (!blob || blob.size >= file.size) return file;

    var name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
  } catch (e) {
    return file;
  }
}

// Shrinks every image file in `formData` under the given field names, in place.
export async function compressFormDataImages(formData, fields) {
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    var files = formData.getAll(field).filter(function (f) { return f && f.size > 0 && f.name; });
    if (!files.length) continue;

    var compressed = [];
    for (var j = 0; j < files.length; j++) {
      compressed.push(await compressImage(files[j]));
    }

    formData.delete(field);
    for (var k = 0; k < compressed.length; k++) {
      formData.append(field, compressed[k], compressed[k].name);
    }
  }
  return formData;
}

export function totalUploadSize(formData) {
  var total = 0;
  formData.forEach(function (value) {
    if (value && typeof value.size === 'number') total += value.size;
    else if (typeof value === 'string') total += value.length;
  });
  return total;
}
